import { Bars3Icon } from '@heroicons/react/24/outline'
import {
  Button,
  LinkExternal,
  LinkInternal,
  type NavigationElement,
  type NavigationElementDropdown,
  NavigationElementType,
  NavigationListItem,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuPrimitive,
  NavigationMenuTrigger,
  Separator,
} from '@sushiswap/ui'
import { DiscordIcon } from '@sushiswap/ui/icons/DiscordIcon'
import { GithubIcon } from '@sushiswap/ui/icons/GithubIcon'
import { XIcon } from '@sushiswap/ui/icons/XIcon'

export const EXPLORE_NAVIGATION_LINKS =
  (): NavigationElementDropdown['items'] => {
    return [
      {
        title: 'Swap',
        href: '/swap',
        description: 'The easiest way to trade.',
      },
      {
        title: 'Explore',
        href: '/explore/pools',
        description: 'Explore top pools.',
      },
      {
        title: 'Pool',
        href: '/pool',
        description: 'Earn fees by providing liquidity.',
      },
      {
        title: 'Claim',
        href: '/claim',
        description: 'Claim your fees and rewards.',
      },
    ]
  }

export const headerElements = (): NavigationElement[] => {
  return [
    {
      show: 'mobile',
      type: NavigationElementType.Custom,
      item: (
        <NavigationMenuItem className={NavigationElementType.Custom}>
          <NavigationMenuPrimitive.Trigger asChild>
            <Button variant="secondary" className="ml-1">
              <Bars3Icon className="h-5 w-5" />
            </Button>
          </NavigationMenuPrimitive.Trigger>
          <NavigationMenuContent>
            <ul className="gap-3 p-4 w-[250px]">
              {EXPLORE_NAVIGATION_LINKS().map((component) => (
                <NavigationListItem
                  key={component.title}
                  title={component.title}
                  href={component.href}
                >
                  {component.description}
                </NavigationListItem>
              ))}
              <Separator />
              <div className="px-3 py-4 flex flex-col gap-4">
                <div className="flex justify-between">
                  <span className="text-sm text-muted-foreground cursor-default">
                    Socials
                  </span>
                  <div className="flex gap-5 items-center">
                    <LinkExternal href={'https://sushi.com/github'}>
                      <GithubIcon
                        width={18}
                        height={18}
                        className="text-muted-foreground hover:text-accent-foreground focus:text-accent-foreground"
                      />
                    </LinkExternal>
                    <LinkExternal href={'https://sushi.com/discord'}>
                      <DiscordIcon
                        width={18}
                        height={18}
                        className="text-muted-foreground hover:text-accent-foreground focus:text-accent-foreground"
                      />
                    </LinkExternal>
                    <LinkExternal href={'https://sushi.com/twitter'}>
                      <XIcon
                        width={18}
                        height={18}
                        className="text-muted-foreground hover:text-accent-foreground focus:text-accent-foreground"
                      />
                    </LinkExternal>
                  </div>
                </div>
              </div>
            </ul>
          </NavigationMenuContent>
        </NavigationMenuItem>
      ),
    },
    {
      title: 'Swap',
      href: '/swap',
      show: 'desktop',
      type: NavigationElementType.Single,
    },
    {
      title: 'Explore',
      href: '/explore/pools',
      show: 'desktop',
      type: NavigationElementType.Single,
    },
    {
      show: 'desktop',
      type: NavigationElementType.Custom,
      item: (
        <NavigationMenuItem className={NavigationElementType.Custom}>
          <NavigationMenuTrigger>
            <LinkInternal href="/pool">Positions</LinkInternal>
          </NavigationMenuTrigger>
          <NavigationMenuContent>
            <ul className="w-[400px] gap-3 p-4">
              <NavigationListItem title={'Manage'} href="/pool">
                Manage liquidity pool positions.
              </NavigationListItem>
              <NavigationListItem title={'Claim'} href="/claim">
                Claim your fees and rewards.
              </NavigationListItem>
            </ul>
          </NavigationMenuContent>
        </NavigationMenuItem>
      ),
    },
  ]
}
